import { AdditionalPageOptions, BenefitListCmsConfig } from '../interface';

/**
 * Get CMS config from additionalPageOptions.
 * Note: If the "window.additionalPageOptions" passed the cmsConfigValidator,
 * then we can cast it to AdditionalPageOptions interface.
 */
export const getCMSConfig = () => window.additionalPageOptions as AdditionalPageOptions;

/**
 * Get data for the vertical list.
 * @param {string} routerId Metacode of router product.
 * @returns {BenefitListCmsConfig[]} Data for vertival list.
 */
export const getBenefitListCMSConfig = (routerId: string): BenefitListCmsConfig[]=> {
    return Object.values(getCMSConfig().routerBenefits).filter(cmsBenefit =>
        Object.values(cmsBenefit.applyForRouters ?? {}).includes(routerId)
    );
};
